import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  token: null,
  user: null,
};

export const auth = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    setAuthToken: (state, action) => {
      state.token = action.payload;
    },
    setAuthUser: (state, action) => {
      state.user = action.payload;
    },
  },
});

export const { setAuthToken, setAuthUser } = auth.actions;

export default auth.reducer;

export const getAuthToken = (state) => state?.auth?.user?.auth_token;
export const getAuthUser = (state) => state?.auth?.user;
